// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.application-page {
  min-height: 100vh;
  padding: 0;
  margin: 0;
}
.application-page .company-logo {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.application-page .company-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.application-page .company-logo svg {
  color: #666;
}
.application-page .job-description-content {
  line-height: 1.6;
}
.application-page .job-description-content h1,
.application-page .job-description-content h2,
.application-page .job-description-content h3,
.application-page .job-description-content h4,
.application-page .job-description-content h5,
.application-page .job-description-content h6 {
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  color: #333;
}
.application-page .job-description-content p {
  margin-bottom: 1em;
}
.application-page .job-description-content ul,
.application-page .job-description-content ol {
  padding-left: 2em;
  margin-bottom: 1em;
}
.application-page .job-description-content li {
  margin-bottom: 0.5em;
}
.application-page .job-description-content strong,
.application-page .job-description-content b {
  font-weight: 600;
}
.application-page .job-description-content em,
.application-page .job-description-content i {
  font-style: italic;
}
.application-page .job-description-content a {
  color: #1976d2;
  text-decoration: none;
}
.application-page .job-description-content a:hover {
  text-decoration: underline;
}
.application-page .job-description-content blockquote {
  border-left: 4px solid #e0e0e0;
  padding-left: 1em;
  margin-left: 0;
  margin-right: 0;
  font-style: italic;
  color: #666;
}
.application-page .job-description-content pre {
  background: #f5f5f5;
  padding: 1em;
  border-radius: 4px;
  overflow-x: auto;
}
.application-page .job-description-content code {
  background: #f5f5f5;
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-family: "Courier New", monospace;
}
.application-page .job-description-content table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1em;
}
.application-page .job-description-content table th,
.application-page .job-description-content table td {
  border: 1px solid #ddd;
  padding: 0.5em;
  text-align: left;
}
.application-page .job-description-content table th {
  background: #f5f5f5;
  font-weight: 600;
}

.application-error {
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

@media (max-width: 960px) {
  .application-page .company-logo {
    width: 80px;
    height: 80px;
  }
}
@media (max-width: 600px) {
  .application-page .company-logo {
    width: 60px;
    height: 60px;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Application/style.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,UAAA;EACA,SAAA;AACF;AACE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,wCAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AACN;AAEI;EACE,WAAA;AAAN;AAIE;EACE,gBAAA;AAFJ;AAII;;;;;;EAME,iBAAA;EACA,oBAAA;EACA,WAAA;AAFN;AAKI;EACE,kBAAA;AAHN;AAMI;;EAEE,iBAAA;EACA,kBAAA;AAJN;AAOI;EACE,oBAAA;AALN;AAQI;;EAEE,gBAAA;AANN;AASI;;EAEE,kBAAA;AAPN;AAUI;EACE,cAAA;EACA,qBAAA;AARN;AAUM;EACE,0BAAA;AARR;AAYI;EACE,8BAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AAVN;AAaI;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAXN;AAcI;EACE,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qCAAA;AAZN;AAeI;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;AAbN;AAeM;;EAEE,sBAAA;EACA,cAAA;EACA,gBAAA;AAbR;AAgBM;EACE,mBAAA;EACA,gBAAA;AAdR;;AAoBA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAjBF;;AAqBA;EAEI;IACE,WAAA;IACA,YAAA;EAnBJ;AACF;AAuBA;EAEI;IACE,WAAA;IACA,YAAA;EAtBJ;AACF","sourcesContent":[".application-page {\n  min-height: 100vh;\n  padding: 0;\n  margin: 0;\n\n  .company-logo {\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: white;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    svg {\n      color: #666;\n    }\n  }\n\n  .job-description-content {\n    line-height: 1.6;\n\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n      margin-top: 1.5em;\n      margin-bottom: 0.5em;\n      color: #333;\n    }\n\n    p {\n      margin-bottom: 1em;\n    }\n\n    ul,\n    ol {\n      padding-left: 2em;\n      margin-bottom: 1em;\n    }\n\n    li {\n      margin-bottom: 0.5em;\n    }\n\n    strong,\n    b {\n      font-weight: 600;\n    }\n\n    em,\n    i {\n      font-style: italic;\n    }\n\n    a {\n      color: #1976d2;\n      text-decoration: none;\n\n      &:hover {\n        text-decoration: underline;\n      }\n    }\n\n    blockquote {\n      border-left: 4px solid #e0e0e0;\n      padding-left: 1em;\n      margin-left: 0;\n      margin-right: 0;\n      font-style: italic;\n      color: #666;\n    }\n\n    pre {\n      background: #f5f5f5;\n      padding: 1em;\n      border-radius: 4px;\n      overflow-x: auto;\n    }\n\n    code {\n      background: #f5f5f5;\n      padding: 0.2em 0.4em;\n      border-radius: 3px;\n      font-family: 'Courier New', monospace;\n    }\n\n    table {\n      width: 100%;\n      border-collapse: collapse;\n      margin-bottom: 1em;\n\n      th,\n      td {\n        border: 1px solid #ddd;\n        padding: 0.5em;\n        text-align: left;\n      }\n\n      th {\n        background: #f5f5f5;\n        font-weight: 600;\n      }\n    }\n  }\n}\n\n.application-error {\n  min-height: 50vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n// Responsive adjustments\n@media (max-width: 960px) {\n  .application-page {\n    .company-logo {\n      width: 80px;\n      height: 80px;\n    }\n  }\n}\n\n@media (max-width: 600px) {\n  .application-page {\n    .company-logo {\n      width: 60px;\n      height: 60px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
